/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system-report-summary';
const componentName = 'summary-card';
const prefix = `${moduleName}.${componentName}`;

export const startAndEndTimeLabel = `${prefix}.startAndEndTimeLabel`;
export const utcTimeLabel = `${prefix}.utcTimeLabel`;
export const systemTaskLabel = `${prefix}.systemTaskLabel`;
export const systemReadinessLabel = `${prefix}.systemReadinessLabel`;
export const dryRunLabel = `${prefix}.dryRunLabel`;
export const errorsLabel = `${prefix}.errorsLabel`;
export const warningsLabel = `${prefix}.warningsLabel`;
export const successLabel = `${prefix}.successLabel`;

export const ENGLISH = {
    [startAndEndTimeLabel]: 'Start & End Time',
    [systemReadinessLabel]: 'System Readiness',
    [dryRunLabel]: 'Dry Run Report',
    [systemTaskLabel]: 'System Task',
    [errorsLabel]: 'Errors',
    [warningsLabel]: 'Warnings',
    [successLabel]: 'Success',
};
